/**
 * THE selected-card treatment.
 *
 * A wizard is a page of option cards, and every step used to invent its own
 * "selected" look — `border-champagne` + `bg-champagne/10` + `ring-2
 * ring-champagne/30..40`, half of them forced through with `!important`. Ten
 * cards into a flow that reads as a gold page rather than a chosen option.
 *
 * FORM_SPEC §1: champagne is an accent, not a finish. A selected card is a soft
 * tint behind a tinted hairline — no ring, no glow. Solid champagne survives on
 * exactly one thing here, the check disc, which is five pixels across and has no
 * surface to flood.
 */

/** Selected state for a card/tile that draws its own border and fill. */
export const SELECTED_CARD = 'border-champagne/40 bg-champagne/5';

/** The resting state those same cards use. */
export const UNSELECTED_CARD = 'border-hairline bg-surface-sunken/70 hover:bg-surface-sunken';

/**
 * The same recipe for a `<Well>`, which brings its own fill and border in its
 * base class list. The `!` is specificity, not emphasis — the values are
 * identical to `SELECTED_CARD`.
 */
export const SELECTED_WELL = '!border-champagne/40 !bg-champagne/5';

/** The check glyph disc on a selected card — the one place solid champagne is allowed. */
export const SELECTED_CHECK_DISC =
  'flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-champagne';

/** Selected state for a small chip: a step pill, a category filter, a tab. */
export const SELECTED_CHIP = 'bg-champagne/10 text-fg-strong';

/** `selected ? SELECTED_CARD : unselected` — the whole helper, spelled once. */
export function selectedCardClass(
  selected: boolean,
  unselected: string = UNSELECTED_CARD,
): string {
  return selected ? SELECTED_CARD : unselected;
}
